import { gql } from '@apollo/client';

export const ADD_NEW_ACTIVITY = gql`
  mutation AddActivityLibrary(
    $coachId: String!
    $name: String!
    $objective: String!
    $customMessage: String!
    $folderId: String
    $steps: [LibraryStepsType!]!
  ) {
    addActivityLibrary(
      addActivityLibraryInput: {
        coachId: $coachId
        name: $name
        objective: $objective
        customMessage: $customMessage
        folderId: $folderId
        steps: $steps
      }
    ) {
      activity {
        id
      }
      activityStep {
        id
        link
        asset
      }
    }
  }
`;

export const EDIT_ACTIVITY = gql`
  mutation EditActivityLibrary(
    $id: String!
    $coachId: String!
    $name: String!
    $objective: String!
    $customMessage: String!
    $steps: [EditLibraryStepsType!]!
  ) {
    editActivityLibrary(
      editActivityLibraryInput: {
        id: $id
        coachId: $coachId
        name: $name
        objective: $objective
        customMessage: $customMessage
        steps: $steps
      }
    ) {
      activity {
        id
      }
      activityStep {
        id
        link
        asset
      }
    }
  }
`;

export const CREATE_NEW_FOLDER = gql`
  mutation AddFolder($coachId: String!, $name: String!) {
    addFolder(addActivityInput: { coachId: $coachId, name: $name }) {
      id
      coachId
      name
      createdAt
      updatedAt
      archive
    }
  }
`;

export const RENAME_FOLDER = gql`
  mutation EditFolder($coachId: String!, $name: String!, $id: String!) {
    editFolder(editFolderInput: { coachId: $coachId, name: $name, id: $id }) {
      id
      coachId
      name
      createdAt
      updatedAt
      archive
    }
  }
`;

export const GET_USER_FOLDERS_AND_ACTIVITIES = gql`
  query GetUserFoldersAndActivities($coachId: String!, $filterValue: String) {
    getUserFoldersAndActivities(coachId: $coachId, filterValue: $filterValue) {
      folders {
        id
        coachId
        name
        createdAt
        updatedAt
        archive
        folderType
      }
      activityLibraries {
        id
        coachId
        name
        objective
        customMessage
        coverImage
        description
        nextCreate
        createdAt
        updatedAt
        currentStep
        archived
        isAdvanceActivity
        ActivityLibraryStep {
          id
          activityLibraryId
          description
          stepOrder
          text
          asset
          assetType
          createdAt
          updatedAt
          isAdvanceStep
          advanceStepType
          advanceStepData
        }
      }
    }
  }
`;

export const GET_ACTIVITIES_INSIDE_FOLDER = gql`
  query GetActivityLibraries(
    $coachId: String!
    $filterValue: String
    $folderId: String
    $page: Int
    $pageSize: Int
  ) {
    getActivityLibraries(
      coachId: $coachId
      filterValue: $filterValue
      folderId: $folderId
      page: $page
      pageSize: $pageSize
      orderBy: "createdAt"
      order: "desc"
    ) {
      totalActivityCount
      activity {
        id
        coachId
        name
        objective
        customMessage
        coverImage
        description
        nextCreate
        createdAt
        updatedAt
        currentStep
        archived
        isAdvanceActivity
        ActivityLibraryStep {
          id
          activityLibraryId
          description
          stepOrder
          text
          asset
          assetType
          createdAt
          updatedAt
          isAdvanceStep
          advanceStepType
          advanceStepData
        }
      }
    }
  }
`;

export const DELETE_ACTIVITY = gql`
  mutation ActivityLibraryAddToFolder(
    $id: String!
    $coachId: String!
    $isMoveToTrash: Boolean
    $folderId: String
  ) {
    ActivityLibraryAddToFolder(
      ActivityLibraryAddToFolderInput: {
        id: $id
        coachId: $coachId
        isMoveToTrash: $isMoveToTrash
        folderId: $folderId
      }
    ) {
      id
      coachId
      name
      objective
      customMessage
      coverImage
      description
      nextCreate
      createdAt
      updatedAt
      currentStep
      archived
      isAdvanceActivity
    }
  }
`;

export const DELETE_FOLDER = gql`
  mutation DeleteFolder($folderId: String!, $coachId: String!) {
    deleteFolder(deleteFolderInput: { folderId: $folderId, coachId: $coachId }) {
      id
      coachId
      name
      createdAt
      archive
      updatedAt
    }
  }
`;

export const PERMANENTLY_DELETE_ACTIVITY = gql`
  mutation DeleteActivityLibrary($id: String!) {
    deleteActivityLibrary(id: $id) {
      id
      coachId
      name
      folderId
      objective
      customMessage
      coverImage
      description
      nextCreate
      createdAt
      updatedAt
      currentStep
      archived
      isAdvanceActivity
    }
  }
`;

export const CHECK_ACTIVITY_LIBRARY_EXISTENCE = gql`
  query checkActivityLibraryExistence(
    $checkActivityLibraryExistenceInput: CheckActivityLibraryExistenceInput!
  ) {
    checkActivityLibraryExistence(
      checkActivityLibraryExistenceInput: $checkActivityLibraryExistenceInput
    ) {
      success
      message
      statusCode
    }
  }
`;
